import React from 'react'
import PropTypes from 'prop-types'
import Container from '@parkholidays/legacy_components/dist/container'
import Typography from '@parkholidays/legacy_components/dist/typography'
import Card, {CardContent} from '@parkholidays/legacy_components/dist/card'
import Button from '@parkholidays/legacy_components/dist/button'
import withCheckoutLayout from '../../layouts/withCheckoutLayout'
import CheckoutHeader from '../../components/CheckoutHeader'
import CardHeader from './components/CardHeader'
import CardHeaderImage from './components/CardHeaderImage'
import WifiVoucherCode from './components/WifiVoucherCode'
import StyledInput from './components/MobilePhoneNumber'
import CardActions from './components/CardActions'
import {datadogLogger} from '../../datadogLogger/logger'
import { sendDirectProxy } from '../../utils/sendDirectProxy'
import { generateId } from '../../utils/generateId'

const propTypes = {
    isProduction: PropTypes.bool,
    isStaging: PropTypes.bool,
    isToBeFlow: PropTypes.bool,
    voucher: PropTypes.string.isRequired,
    parkCode: PropTypes.string.isRequired,
    clientMac: PropTypes.string,
    apMac: PropTypes.string,
    validFrom: PropTypes.string,
    validTo: PropTypes.string,
    siteId: PropTypes.string,
    proxyUrl: PropTypes.string,
    proxyKey: PropTypes.string,
    transactionId: PropTypes.string,
    customerEmail: PropTypes.string,
    selectedProduct: PropTypes.shape({
        duration: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
    }),
}

const successMessage =
    `Your code has been sent by SMS. If you haven't received your
code by text, please check your mobile number and try again.`

const failureMessage =
    `Something went wrong on our end. Please remain
on this page & try again later.`

const autoEmailSuccessMessage =
    `Your voucher has been emailed to the email address used for your payment. please check your spam or junk folder. If you entered the wrong email address, you may need to try again.`

const emailSuccessMessage =
    `We’ve emailed your code. If you don’t see it in your inbox, please check your spam or junk folder. If you entered the wrong email address, you may need to try again.`

const emailFailureMessage =
    `Something went wrong on our end. Please remain
on this page & try again later.`

const mobileViewPort = 769;


const sendCodeBySMSLoading= 'SendCodeBySMSLoading';
const sendCodeByEmailLoading= 'SendCodeByEmailLoading';
const getOnlineSuccess = 'getOnlineSuccess';
const getOnlineError = 'getOnlineError';
const getOnlinePending = 'getOnlinePending';

const Confirmation = ({   isProduction,
                          isStaging,
                          isToBeFlow,
                          voucher,
                          parkCode,
                          clientMac,
                          apMac,
                          validFrom,
                          validTo,
                          siteId,
                          proxyUrl,
                          proxyKey,
                          transactionId,
                          customerEmail,
                          selectedProduct: {duration}
                      }) => {
    const voucherInputRef = React.createRef()
    const hasRequestedVoucherAccessRef = React.useRef(false)

    React.useEffect(() => {
        localStorage.removeItem('journeyContext')
    }, [])
    const [form, setForm] =React.useState({
        phone: '',
        email: '',
      });
    const [isMobile, setIsMobile] = React.useState("false");
    const [getOnlineStatus, setGetOnlineStatus] = React.useState(null);

    React.useEffect(()=> {
        setIsMobile(window.innerWidth < mobileViewPort)
    },[setIsMobile])

    React.useEffect(() => {
        if (hasRequestedVoucherAccessRef.current || (!isProduction && !isStaging)) {
            return
        }

        hasRequestedVoucherAccessRef.current = true
        setGetOnlineStatus(getOnlinePending)

        const validFromDate = new Date(validFrom)
        const validToDate = new Date(validTo)
        const minutes = Math.ceil((validToDate.getTime() - validFromDate.getTime()) / 60000)

        if (!parkCode || !clientMac || !apMac || !Number.isFinite(minutes) || minutes <= 0) {
            setGetOnlineStatus(getOnlineError)
            datadogLogger.error(`confirmation VFast guests POST skipped parkCode-${parkCode} clientMac-${clientMac} apMac-${apMac} validFrom-${validFrom} validTo-${validTo} minutes-${minutes}`)
            return
        }

        if (isToBeFlow) {
            const requestId = generateId()
            sendDirectProxy({
                url: proxyUrl,
                key: proxyKey,
                payload: { park: parkCode, siteId, guest: { client_mac: clientMac, ap_mac: apMac, minutes } },
                requestId,
                context: { parkCode, siteId, clientMac, apMac },
                logger: datadogLogger,
                logPrefix: 'confirmation',
            })
                .then(() => {
                    setGetOnlineStatus(getOnlineSuccess)
                    datadogLogger.info('confirmation: direct proxy success - WiFi granted', { requestId, parkCode, siteId, clientMac, apMac, minutes })
                })
                .catch(() => {
                    setGetOnlineStatus(getOnlineError)
                })
            return
        }

        // As-Is flow: raw XHR to old vFast proxy
        datadogLogger.info(`confirmation VFast guests POST parkCode-${parkCode} clientMac-${clientMac} apMac-${apMac} minutes-${minutes}`)

        const xhr = new XMLHttpRequest()
        xhr.open('POST', proxyUrl, true)
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.setRequestHeader('x-lambda-key', proxyKey)
        xhr.ontimeout = () => {
            setGetOnlineStatus(getOnlineError)
            datadogLogger.info(`confirmation VFast guests POST timeout responseText-${xhr.responseText} status-${xhr.status}`)
        }

        xhr.onload = () => {
            if (xhr.status !== 200) {
                setGetOnlineStatus(getOnlineError)
                datadogLogger.error(`confirmation VFast guests POST unexpected status-${xhr.status} responseText-${xhr.responseText}`)
                return
            }
            try {
                const {status} = JSON.parse(xhr.responseText)
                if (status === 'ok') {
                    setGetOnlineStatus(getOnlineSuccess)
                } else {
                    setGetOnlineStatus(getOnlineError)
                    datadogLogger.error(`confirmation VFast guests POST unexpected response body: ${xhr.responseText}`)
                }
            } catch (e) {
                setGetOnlineStatus(getOnlineError)
                datadogLogger.error(`confirmation VFast guests POST failed to parse response: ${xhr.responseText} error: ${e?.message || e}`)
            }
        }

        xhr.onerror = () => {
            setGetOnlineStatus(getOnlineError)
            const textResponses = ["", "text"]
            if (textResponses.includes(xhr.responseType)) {
                datadogLogger.info(`confirmation VFast guests POST onerror text response type responseText-${xhr.responseText}`)
            }
            if (xhr.responseType === "json") {
                datadogLogger.info(`confirmation VFast guests POST onerror json response type responseText-${JSON.parse(xhr.responseText)}`)
            }
            datadogLogger.error(`confirmation VFast guests POST onerror responseText-${xhr.responseText} status-${xhr.status}`)
        }

        xhr.send(
            JSON.stringify({
                park: parkCode,
                siteId,
                guest: {
                    client_mac: clientMac,
                    ap_mac: apMac,
                    minutes,
                },
            }),
        )
    }, [apMac, clientMac, isProduction, isStaging, isToBeFlow, parkCode, proxyKey, proxyUrl, siteId, validFrom, validTo])
      
      const [validation, setValidation] = React.useState({
        phone: false,
        email: false,
      });
      
    const [sentCodeByMobile, setSentCodeByMobile] = React.useState(null)
    const [sentCodeByEmail, setSentCodeByEmail] = React.useState(null)
    const [autoEmailSent, setAutoEmailSent] = React.useState(null)
    const [isLoading, setIsLoading] = React.useState(null);

    React.useEffect(() => {
        if (!transactionId || !voucher) {
            return
        }
        const emailLambda = isProduction
            ? "https://f8t9f6xt7k.execute-api.eu-west-2.amazonaws.com/production/service"
            : "https://thi8iaerk0.execute-api.eu-west-2.amazonaws.com/staging/service"
        const payload = { transactionId, voucherCode: voucher }
        if (customerEmail) {
            payload.emailAddress = customerEmail
        }
        datadogLogger.info(`confirmation auto-email transactionId-${transactionId} emailPresent-${!!customerEmail}`)
        fetch(emailLambda, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(res => {
                if (res.ok) {
                    setAutoEmailSent(true)
                    datadogLogger.info(`confirmation auto-email sent transactionId-${transactionId}`)
                } else {
                    setAutoEmailSent(false)
                    datadogLogger.error(`confirmation auto-email failed status-${res.status} transactionId-${transactionId}`)
                }
            })
            .catch(err => {
                setAutoEmailSent(false)
                datadogLogger.error(`confirmation auto-email error transactionId-${transactionId} error-${err?.message || err}`)
            })
    }, [transactionId, voucher, isProduction, customerEmail])

    const renderGetOnlineStatus = (color = "white") => {
        if (getOnlineStatus === getOnlineSuccess) {
            return (
                <Typography as="p" color={color} $style={{margin: '0 16px 16px'}}>
                    You&apos;re online now.
                </Typography>
            )
        }

        if (getOnlineStatus === getOnlineError) {
            return (
                <Typography as="p" color={color} $style={{margin: '0 16px 16px'}}>
                    There was a problem getting you online. Please try again in a few moments using your voucher code.
                </Typography>
            )
        }

        return null
    }

    const copyToClipboard = (e) => {
        e.preventDefault()
        voucherInputRef.current.select()
        document.execCommand('copy')
    }

    const sendCodeBySMS = async () => {
        setIsLoading(sendCodeBySMSLoading);

        try {
            const stagingSMSLambda = "https://zqnsf8imx4.execute-api.eu-west-2.amazonaws.com/staging/service";
            datadogLogger.info(`env ${JSON.stringify(process.env)}`);
            // eslint-disable-next-line max-len
            datadogLogger.info(`Send SMS lambdaFunctionURL - ${stagingSMSLambda}`)
            const response = await fetch(stagingSMSLambda,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        mobilePhoneNumber: form.phone,
                        voucher: voucher,
                    }),
                }
            );
            if (response.ok) {
                // The request was successful
                setSentCodeByMobile(true);
                datadogLogger.info(`Send SMS worked ok - ${await response.text()}`)
            } else {
                const errorText = await response.text();
                setSentCodeByMobile(false);
                // eslint-disable-next-line max-len
                console.error(`Failed to send: ${response.statusText || errorText}`);
            }
        } catch (err) {
            setSentCodeByMobile(false);
            datadogLogger.error(`Send SMS error was - ${err?.message || err}`)
        } finally {
            // Always set loading to false at the end of the process
            setIsLoading(null);
        }
    };

    const sendCodeByEmail = async () => {
        setIsLoading(sendCodeByEmailLoading);

        try {
            const emailLambda = isProduction ? "https://f8t9f6xt7k.execute-api.eu-west-2.amazonaws.com/production/service" : "https://thi8iaerk0.execute-api.eu-west-2.amazonaws.com/staging/service";
            const response = await fetch(emailLambda,
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        emailAddress: form.email,
                        voucherCode: voucher,
                    }),
                }
            );
            if (response.ok) {
                setSentCodeByEmail(true);
                datadogLogger.info(`Send Email worked ok`)
            } else {
                const errorText = await response.text();
                setSentCodeByEmail(false);
                datadogLogger.error(`Send Email failed status-${response.status} error-${errorText}`)
            }
        } catch (err) {
            setSentCodeByEmail(false);
            datadogLogger.error(`Send Email error was - ${err?.message || err}`)
        } finally {
            // Always set loading to false at the end of the process
            setIsLoading(null);
        }
    };
      
    const validate = {
        phone: (val) =>
          /^(\+44|0)7\d{9}$|^020[78]\d{7}$/.test(val.replace(/\s+/g, '')),
        email: (val) =>
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim()),
      };
      
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
          ...prev,
          [name]: value,
        }));
      
        setValidation((prev) => ({
          ...prev,
          [name]: validate[name]?.(value) || false,
        }));
      };
      
    const renderMobile = () => {
        return (
            <>
            <CheckoutHeader>
                <Container>
                    <Typography as="h1">
                        Your Voucher code
                    </Typography>
                    <Typography as="p">
                        Congratulations – you’re almost there. 
                        <br></br>
                        <b>COPY YOUR CODE BEFORE YOU TRY AND USE IT.</b>
                    </Typography>
                    {renderGetOnlineStatus("corporate")}
                    <b>This code is valid on up to 6 devices.</b>
                    <Typography as="p">
                        <b>Write</b> it down, <b>text</b> or <b>email</b> it to yourself  or <b>screenshot</b> this page.
                    </Typography>
                </Container>
            </CheckoutHeader>
            <Container>
                <Card color="white" elevation={3} $style={{marginBottom: '16px'}}>
                    <CardHeader>
                        <Typography
                            as="h2"
                            color="white"
                            noMargins
                            $style={{float: 'left'}}
                        >
                            {`Your ${duration}-day`}
                            <br/>
                            wifi voucher code
                        </Typography>
                        <CardHeaderImage
                            src={`https://park-holidays.s3.eu-west-2.amazonaws.com/assets/checkout/illustrations-${duration}day.png`}
                            alt="Duration Image"
                        />
                    </CardHeader>
                    <CardContent>
                        <WifiVoucherCode
                            value={voucher}
                            ref={voucherInputRef}
                            readOnly
                            tabIndex="0"
                        />
                        <CardActions>
                            <Button
                                color="touring"
                                role="button"
                                tabIndex="0"
                                onClick={(e) => copyToClipboard(e)}
                                fullWidth
                            >
                                Copy to Clipboard
                            </Button>
                        </CardActions>
                    </CardContent>
                </Card>
                <Card color="white" elevation={3} $style={{backgroundColor: '#ececec', marginBottom: '16px'}}>
                    <CardHeader $style={{backgroundColor: '#ececec'}}>
                        <Typography as="h2" noMargins color="corporate">
                            Forward the code to your mobile phone 
                        </Typography>
                    </CardHeader>
                    <CardContent>
                        {sentCodeByMobile === true ? (
                            (<Typography as="p" color="corporate">
                                {successMessage}
                            </Typography>)
                        ) : sentCodeByMobile !== false ? null :
                            (<Typography as="p" color="corporate">
                                {failureMessage}
                            </Typography>)}
                        <StyledInput
                            type="tel"
                            name="phone"
                            value={form.phone}
                            onChange={handleInputChange}
                            placeholder="e.g. 07700123456"
                        />
                        <CardActions>
                            <Button
                                color="corporate"
                                disabled={!validation.phone || isLoading===sendCodeBySMSLoading}
                                role="link"
                                tabIndex="0"
                                onClick={(e) => sendCodeBySMS()}
                                fullWidth
                                $style={{ Border: '1px', borderColor: '#666666'}}
                            >
                                {(isLoading===sendCodeBySMSLoading) ? "TEXTING CODE TO MOBILE" : "TEXT CODE TO MOBILE" }
                            </Button>
                        </CardActions>
                    </CardContent>
                    <CardHeader $style={{backgroundColor: '#ececec'}}>
                        <Typography as="h2" noMargins color="corporate">
                            Forward the code to your email address
                        </Typography>
                    </CardHeader>
                    <CardContent>
                        {autoEmailSent === true && sentCodeByEmail === null && (
                            <Typography as="p" color="corporate">
                                {autoEmailSuccessMessage}
                            </Typography>
                        )}
                        {sentCodeByEmail === true ? (
                            (<Typography as="p" color="corporate">
                                {emailSuccessMessage}
                            </Typography>)
                        ) : sentCodeByEmail !== false ? null :
                            (<Typography as="p" color="corporate">
                                {emailFailureMessage}
                            </Typography>)}
                        <StyledInput
                           type="email"
                           name="email"
                           value={form.email}
                           onChange={handleInputChange}
                           placeholder="e.g. you@test.com"
                        />
                        <CardActions>
                            <Button
                                color="corporate"
                                disabled={!validation.email || isLoading===sendCodeByEmailLoading}
                                role="link"
                                tabIndex="0"
                                onClick={(e) => sendCodeByEmail()}
                                fullWidth
                                $style={{ Border: '1px', borderColor: '#666666'}}
                            >
                                {(isLoading===sendCodeByEmailLoading) ? "SENDING CODE AS EMAIL" : "SEND CODE AS EMAIL"}
                            </Button>
                        </CardActions>
                    </CardContent>
                </Card>
                <Card color="white" elevation={3}>
                    <CardContent $style={{backgroundColor: "#243645"}}>
                        {renderGetOnlineStatus()}
                        <div className="vfast-logo" style={{ justifySelf: "center"}}> 
                          <img 
                            src="https://eu-images.contentstack.com/v3/assets/blt321e8804c3801f0c/blt2da4d08f8f9cce7a/67fd78b21171ad0e017aa853/vfast_logo-900x250.png" 
                            alt="vfastinternet - part of the Orbital Internet Group"
                            style={{ maxWidth: '200px', height: 'auto' }}
                          />
                        </div>
                    </CardContent>
                    <CardContent $style={{backgroundColor: "#D1EAEF"}}>
                        <Typography as="strong" color="corporate" $style={{display: 'block', padding: "8px 0px"}}>
                            Terms and Conditions
                        </Typography>
                        <Typography as="p" color="corporate" $style={{padding: "8px 0px"}}>
                            By using our internet service, you hereby expressly acknowledge and
                            agree that there are significant security, privacy and confidentiality
                            risks inherent in accessing or transmitting information through the
                            internet, whether the connection is facilitated through wired or
                            wireless technology.
                        </Typography>
                    </CardContent>
                </Card>
         
            </Container>
        </>
        )
    }

    const renderDesktop = () => {
        return (
            <div style={{display:"flex", height: "100vh"}} >
            <CheckoutHeader >
                <Container>
                    <Typography as="h1">
                        Your Voucher code
                    </Typography>
                    <Typography as="p">
                        Congratulations – you’re almost there. 
                        <br></br>
                        <b>COPY YOUR CODE BEFORE YOU TRY AND USE IT.</b>
                    </Typography>
                    {renderGetOnlineStatus("corporate")}
                    <b>This code is valid on up to 6 devices.</b>
                    <Typography as="p">
                        <b>Write</b> it down, <b>text</b> or <b>email</b> it to yourself  or <b>screenshot</b> this page.
                    </Typography>
                </Container>
            </CheckoutHeader>
            <Container  $style={{ padding:35, margin:0 }} >
                <Card color="white" elevation={3} $style={{marginBottom: '16px'}}>
                    <CardHeader style={{height:52}} >
                        <Typography
                            as="h2"
                            color="white"
                            noMargins
                            $style={{float: 'left'}}
                        >
                            {`Your ${duration}-day wifi voucher code`}
                        </Typography>
                        <CardHeaderImage
                        style={{height:40,width:40,margin:0}}
                            src={`https://park-holidays.s3.eu-west-2.amazonaws.com/assets/checkout/illustrations-${duration}day.png`}
                            alt="Duration Image"
                        />
                    </CardHeader>
                    <CardContent style={{
                        display:'flex',
                        justifyContent:'space-between',
                        alignItems:'center'
                        }} 
                    >
                        <WifiVoucherCode
                            value={voucher}
                            ref={voucherInputRef}
                            readOnly
                            tabIndex="0"
                            style={{margin:0,width:'fit-content'}}
                        />
                        <CardActions style={{margin:0,height:'fit-content'}} >
                            <Button
                                color="touring"
                                role="button"
                                tabIndex="0"
                                onClick={(e) => copyToClipboard(e)}
                                fullWidth
                            >
                                Copy to Clipboard
                            </Button>
                        </CardActions>
                    </CardContent>
                </Card>
                <Card color="white" elevation={3} $style={{backgroundColor: '#ececec', marginBottom: '16px'}}>
                    <CardHeader $style={{backgroundColor: '#ececec',height:'fit-content'}}>
                        <Typography as="h2" noMargins color="corporate">
                            Forward the code to your mobile phone 
                        </Typography>
                    </CardHeader>
                    <CardContent style={{paddingBottom:'55px'}} >
                        {sentCodeByMobile === true ? (
                            (<Typography as="p" color="corporate">
                                {successMessage}
                            </Typography>)
                        ) : sentCodeByMobile !== false ? null :
                            (<Typography as="p" color="corporate">
                                {failureMessage}
                            </Typography>)}
                        <div style={{display:'flex',justifyContent:'space-between'}}>
                            <StyledInput
                                style={{border:'1px solid #666666',height:64,width:450,margin:0}}
                                    type="tel"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleInputChange}
                                    placeholder="e.g. 07700123456"
                            />
                            <CardActions style={{height:64,margin:0,width:316}} >
                                <Button
                                    color="corporate"
                                    disabled={!validation.phone || isLoading===sendCodeBySMSLoading}
                                    role="link"
                                    tabIndex="0"
                                    onClick={(e) => sendCodeBySMS()}
                                    fullWidth
                                    $style={{ Border: '1px', borderColor: '#666666'}}
                                >
                                    {(isLoading===sendCodeBySMSLoading) ? "TEXTING CODE TO MOBILE" : "TEXT CODE TO MOBILE"}
                                </Button>
                            </CardActions>
                        </div>
                    </CardContent>
                </Card>

                <Card elevation={3} $style={{backgroundColor: '#ececec', marginBottom: '16px'}} >
                    <CardHeader $style={{backgroundColor: '#ececec',height:'fit-content'}}>
                        <Typography as="h2" noMargins color="corporate">
                            Forward the code to your email address
                        </Typography>
                    </CardHeader>
                    <CardContent style={{paddingBottom:'55px'}}>
                        {autoEmailSent === true && sentCodeByEmail === null && (
                            <Typography as="p" color="corporate">
                                {autoEmailSuccessMessage}
                            </Typography>
                        )}
                        {sentCodeByEmail === true ? (
                            (<Typography as="p" color="corporate">
                                {emailSuccessMessage}
                            </Typography>)
                        ) : sentCodeByEmail !== false ? null :
                            (<Typography as="p" color="corporate">
                                {emailFailureMessage}
                            </Typography>)}
                        <div style={{display:'flex',justifyContent:'space-between'}}>
                            <StyledInput
                                style={{border:'1px solid #666666',height:64,width:450,margin:0}}
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleInputChange}
                            placeholder="e.g. you@test.com"
                            />
                            <CardActions style={{height:64,margin:0,width:316}}>
                                <Button
                                    color="corporate"
                                    disabled={!validation.email || isLoading===sendCodeByEmailLoading}
                                    role="link"
                                    tabIndex="0"
                                    onClick={(e) => sendCodeByEmail()}
                                    fullWidth
                                    $style={{ Border: '1px', borderColor: '#666666'}}
                                >
                                    {(isLoading===sendCodeByEmailLoading) ? "SENDING CODE AS EMAIL" : "SEND CODE AS EMAIL"}
                                </Button>
                            </CardActions>
                        </div>
                    </CardContent>
                </Card>

                <Card color="white" elevation={3}
                    $style={{marginBottom: '58px'}}
                >
                    <CardContent $style={{
                        backgroundColor: "#243645",
                        display:'flex',
                        justifyContent:'space-between',
                        alignItems:'center'
                        }}>
                       
                        <div style={{width:'316px'}} className="vfast-logo">
                          <img 
                            src="https://eu-images.contentstack.com/v3/assets/blt321e8804c3801f0c/blt2da4d08f8f9cce7a/67fd78b21171ad0e017aa853/vfast_logo-900x250.png" 
                            alt="vfastinternet - part of the Orbital Internet Group"
                            style={{ maxWidth: '100%', height: 'auto' }}
                          />
                        </div>
                        {renderGetOnlineStatus()}
                    </CardContent>
                    
                </Card>

                <Card>
                    <CardContent $style={{backgroundColor: "#D1EAEF",padding:'0 !important'}}>
                        <Typography 
                        as="strong" 
                        color="corporate" 
                        $style={{
                            display: 'block', 
                            padding: "0px",
                            paddingBottom: '8px'
                        }}>
                            Terms and Conditions
                        </Typography>
                        <Typography as="p" color="corporate" $style={{padding: "8px 0px"}}>
                            By using our internet service, you hereby expressly acknowledge and
                            agree that there are significant security, privacy and confidentiality
                            risks inherent in accessing or transmitting information through the
                            internet, whether the connection is facilitated through wired or
                            wireless technology.
                        </Typography>
                        {/* <a
                            href={privacyPolicy}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#0C5595', textDecoration: 'underline' }}
                        >
                            Privacy Policy
                        </a> */}
                    </CardContent>
                </Card>
         
            </Container>
        </div>
        )
    }

    return isMobile ? 
    renderMobile() :  
    renderDesktop()
}

Confirmation.propTypes = propTypes

export default withCheckoutLayout(Confirmation);
